<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col align="center" justify="center">
        <h1>推薦書單</h1>
      </v-col>
    </v-row>
    <v-card class="mx-auto my-6" max-width="374" elevation="2" outlined>

      <v-row v-for="(book, idx) in recommendedBooks" :key="book.id" dense>
        <book-card
          @click="showDialog = true; currentBookNumber = book.book_number; currentBookId = idx"
          :title="book.title"
          :desc="book.descShort"
          :imageUrl="'/img/books/' + book.id + '_bc.jpeg'"
        ></book-card>
      </v-row>
    </v-card>
    <br /><br /><br />
    <br /><br /><br />
    <v-dialog
      v-model="showDialog"
      max-width="290"
    >
    <v-card v-if="showDialog">
        <v-card-title class="headline">
          {{this.recommendedBooks[this.currentBookId].title}}
        </v-card-title>

        <v-card-text>
          {{this.recommendedBooks[this.currentBookId].desc}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="changeBook()"
          >
            已經買過這本書(換書)
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="showDialog = false"
          >
            返回
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col align="center" justify="center" class="fixed-button">
        <v-btn rounded color="success" dark x-large @click="goToSubscribe()">
          書單確認
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import bookJSON from "@/data/book.json";
import BookCard from "@/components/BookCard.vue";

let api_url = process.env.VUE_APP_API_URL;

export default {
  name: "BookResult",
  components: { BookCard },
  data() {
    return {
      books: bookJSON,
      recommendedBooks: [],
      showDialog: false,
      currentBookNumber: null,
      currentBookId: null,
      callbackUrlObj: null
    };
  },
  mounted() {
    console.log(this.books);
    // this.pickBooksRandom(4);
    this.getRecommendedBooks();
  },
  methods: {

    pickBooksRandom(numOfBooks) {
      let pickedIds = [];
      for (let idx = 0; idx < numOfBooks; idx++) {
        let pickedId = Math.floor(Math.random() * this.books.length);
        while (pickedIds.includes(pickedId)) {
          pickedId = Math.floor(Math.random() * this.books.length);
        }
        pickedIds.push(pickedId);
        this.recommendedBooks.push(this.books[pickedId]);
      }
      console.log(pickedIds);
      console.log(this.recommendedBooks);
    },
    getRecommendedBooks() {
      var data = JSON.stringify(false);
      var xhr = new XMLHttpRequest();
      this.recommendedBooks = [];
      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            console.log(result);
            result.forEach((book) => {
              let bookData = {
                id: book.book_number,
                title: book.title,
                descShort: (book.summary) ? book.summary.substring(0, 30) + " >> 詳細介紹": "No data",
                desc: book.summary,
              };
              this.recommendedBooks.push(bookData);
            });
          } else {
            alert(result.error.message);
          }
        }
      });

      xhr.open(
        "GET",
        api_url +
          "/api/books/" +
          this.$store.state.userId +
          "/" +
          this.$store.state.familyMemberId.toString() +
          "/"
      );

      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    },
    changeBook() {
      var data = JSON.stringify({
        "book_number": this.recommendedBooks[this.currentBookId].id,
        "status": 2
      });

      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            console.log("success change");
            this.getRecommendedBooks();
            this.showDialog = false;
          } else {
            alert(result.error.message);
          }
        }
      });

      xhr.open(
        "POST",
        api_url +
          "/api/books/" +
          this.$store.state.userId +
          "/" +
          this.$store.state.familyMemberId.toString() +
          "/"
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    },
    // goToSubscribe() {
    //   // let baseUrl = "https://stage.onlyubook.com/lbb/plans";
    //   // let img = "0h9mmYtS3AZkJAIE1BubAYPTBwZShjUT9QbRYvLCFwb3t1QHQRakN9dCIobXF4EXZEa0R7JXdwOHFMMxEkXnaadkcQOHZ7ESIWbEQgrA";
    //   // if (this.$store.state.pictureUrl != undefined) {
    //   //   console.log('has store picture');
    //   //   img = this.$store.state.pictureUrl.split("https://profile.line-scdn.net/")[1]
    //   // }
    //   // console.log(img);
    //   // console.log(this.$store.state.pictureUrl);
    //   // let params = {
    //   //   book1: this.recommendedBooks[0].title,
    //   //   book2: this.recommendedBooks[1].title,
    //   //   book3: this.recommendedBooks[2].title,
    //   //   book4: this.recommendedBooks[3].title,
    //   //   img: img
    //   // };
    //   // let searchParams = new URLSearchParams(params);
    //   // let finalUrl = baseUrl + "?" + searchParams.toString();
    //   // console.log(finalUrl);
    //   // window.open(finalUrl, "_blank");
      
    //   // use server side url
    //   window.open(this.$store.state.loginUrl, "_blank");

    // },

    goToSubscribe() {
      var data = JSON.stringify({
        "access_token": this.$store.state.accessToken
      });

      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", () => {
        if (xhr.readyState === 4) {
          console.log(xhr.responseText);
          let result = JSON.parse(xhr.responseText);
          if (xhr.status == 200) {
            this.callbackUrlObj = new URL(localStorage.getItem("surveryCallback"));
            let callbackParams = this.callbackUrlObj.searchParams;
            callbackParams.set("uid", result.line_id);
            callbackParams.set("ts", result.ts);
            callbackParams.set("sig", result.sig);
            callbackParams.set("member_id", this.$store.state.familyMemberId.toString());
            this.callbackUrlObj.search = callbackParams.toString();
            console.log(this.callbackUrlObj.toString());
            // window.open(this.callbackUrlObj.toString());

            if (this.isMobile()){
              liff.openWindow({url: this.callbackUrlObj.toString(), external: true});
            } else {
              window.location.replace(this.callbackUrlObj.toString());
            }
            
          } else {
            alert(result.error.message);
          }
        }
      });

      xhr.open(
        "POST",
        api_url +
          "/toolbox/get_uid_sig"
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);

    },
    isMobile() {
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
};
</script>

<style>
</style>